import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid2";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import PageLayout from "layouts/PageLayout";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";

const IllustrationLayout = ({
  header = "",
  title = "",
  description = "",
  illustration = "",
  children,
}) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <PageLayout background="white">
      <Grid
        container
        sx={{
          backgroundColor: ({ palette: { background, white } }) =>
            darkMode ? background.default : white.main,
        }}
      >
        <Grid size={{ xs: 12, lg: 6 }}>
          <div
            style={{
              backgroundImage: `url(${illustration})`,
              backgroundSize: "contain", // Make the image cover the container
              backgroundPosition: "center",
              height: "100%", // Allow the container to expand to fit the image
              width: "100%",
              backgroundRepeat: "no-repeat",
            }}
          />
        </Grid>
        <Grid size={{ xs: 11, sm: 8, md: 6, lg: 4, xl: 3 }} sx={{ mx: "auto" }}>
          <MDBox display="flex" flexDirection="column" justifyContent="center" height="100vh">
            <MDBox py={3} px={3} textAlign="center">
              {!header ? (
                <>
                  <MDBox mb={1} textAlign="center">
                    <MDTypography variant="h4" fontWeight="bold">
                      {title}
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant="body2" color="text">
                    {description}
                  </MDTypography>
                </>
              ) : (
                header
              )}
            </MDBox>
            <MDBox p={3}>{children}</MDBox>
          </MDBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
};

IllustrationLayout.propTypes = {
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node.isRequired,
  illustration: PropTypes.string,
};

export default IllustrationLayout;
